module.exports = __webpack_public_path__ + "img/526.30b0b6fd.jpg";